import { Flex } from "@chakra-ui/react";
import { Plus } from "lucide-react";
import { useEffect, useState } from "react";
import { DataTable } from "../components/super-admin/DataTable";
import OrganisationEditorParent from "../components/super-admin/OrganisationEditor";
import SuperAdminSeite from "../components/super-admin/SuperAdminSeite";
import { Button } from "../ui/components/ui/button";
import { Dialog } from "../ui/components/ui/dialog";

/**
 * Die Organisationen im Super-Admin — der erste Punkt des Bereichs (KAN-276, A8).
 *
 * Inhaltlich unveraendert: dieselbe Liste, dieselbe Suche, derselbe Weg zum Anlegen. Neu
 * ist nur, dass sie jetzt in der Unter-Navigation des Bereichs sitzt statt allein auf der
 * Seite zu stehen.
 */
const SuperAdmin = () => (
  <SuperAdminSeite aktiv="organisationen">
    <SuperAdminOrganisationen />
  </SuperAdminSeite>
);

const SuperAdminOrganisationen = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState<string>();

  useEffect(() => {
    if (selectedOrg) {
      setDialogOpen(true);
    }
  }, [selectedOrg]);

  return (
    <>
      <Flex width="100%" justifyContent="space-between" margin="0 0 1.25em" flexWrap="wrap" gap="0.875rem">
        <h1 className="text-[23px] font-bold tracking-tight text-gray-900">Organisationen</h1>
        <Flex gap="1rem" className="flex-col lg:flex-row">
          <Button size="kompakt" className="gap-1.5 text-white" onClick={() => setDialogOpen(true)}>
            <Plus className="h-4 w-4" />
            Organisation erstellen
          </Button>
        </Flex>
      </Flex>
      <DataTable setSelectedOrg={setSelectedOrg} />
      <Dialog
        open={dialogOpen}
        onOpenChange={(value) => {
          setDialogOpen(value);
          if (!value) {
            setSelectedOrg(undefined);
          }
        }}
      >
        <OrganisationEditorParent id={selectedOrg} setSelectedOrgId={setSelectedOrg} />
      </Dialog>
    </>
  );
};

export default SuperAdmin;
